/* unplugin-vue-components disabled */import script from "./topic-view.vue?vue&type=script&setup=true&lang=js"
export * from "./topic-view.vue?vue&type=script&setup=true&lang=js"

import "./topic-view.vue?vue&type=style&index=0&id=c906e980&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\work\\space-0\\fsplus-vue-workspace\\foshan-street\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c906e980"]])

export default __exports__